import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GetUserRoleRequest } from "src/app/core/b2c-user-role-request.model";
import { PrefixedRequestService } from "src/app/core/prefixed-request.service";
import { getEnumMember } from "src/utils";

@Injectable({ providedIn: "root" })
export class B2CUsersService {
  public constructor(private readonly request: PrefixedRequestService) {}

  public getUserRole(request: GetUserRoleRequest): Observable<UserRoleV2> {
    return this.request
      .post({
        prefix: "site",
        path: "/Users/CheckUserRole",
        data: request,
      })
      .pipe(
        map((result) => getEnumMember(UserRoleV2, result, UserRoleV2.Unknown)),
      );
  }
}

export enum UserRole {
  Admin = "Admin",
  PartnerAdmin = "PartnerAdmin",
  LogisticsWorker = "LogisticsWorker",
  Helpdesk = "Helpdesk",
  OpsLeader = "OpsLeader",
  OpsWorker = "OpsWorker",
  Guard = "Guard",
  GuardPlus = "GuardPlus",
  Vendor = "Vendor",
  Carrier = "Carrier",
  Buyer = "Buyer",
  Executive = "Executive",
  Unknown = "Unknown",
  HelpdeskPlus = "HelpdeskPlus",
  OpsLeaderPlus = "OpsLeaderPlus",
}

export enum UserRoleV2 {
  Admin = "admin",
  PartnerAdmin = "partneradmin",
  LogisticsWorker = "logisticsworker",
  Helpdesk = "helpdesk",
  OpsLeader = "opsleader",
  OpsWorker = "opsworker",
  Guard = "guard",
  GuardPlus = "guardplus",
  Vendor = "vendor",
  Carrier = "carrier",
  Buyer = "buyer",
  Executive = "executive",
  Unknown = "Unknown",
  HelpdeskPlus = "helpdeskplus",
  OpsLeaderPlus = "opsleaderplus",
}
